<template>
  <div class="machineCamera col-12 mb-2">
    <div class="text-left">
      <template v-if="machineCameraData.length == 0">
        本機無掛載影像攝相機
      </template>
      <template v-else-if="machineCameraData.length > 1">
        <button
          v-for="(item, key) in machineCameraData"
          :key="key"
          style=""
          class="btn me-2 my-1 machineCameraData"
          :class="{ 'select-button': cameraButton == item.cameraName }"
          @click="
            changeCamera(item.cameraName), (cameraButton = item.cameraName)
          "
        >
          {{ item.cameraName }}
        </button>
        <button
          style=""
          class="btn me-2 my-1 machineCameraData"
          :class="{ 'select-button': cameraButton == 'ALL' }"
          @click="changeCamera('ALL'), (cameraButton = 'ALL')"
        >
          ALL
        </button>
      </template>
    </div>
    <div
      v-if="machineCameraData.length != 0"
      class="col-12 row p-0 mx-0 mb-2"
      style="margin-top: 1.125rem"
    >
      <template v-if="allCamera">
        <img
          v-for="(item, key) in machineCameraData"
          :key="key"
          :id="item.cameraName"
          :src="item.url"
          alt="機台關機中"
          class="me-3 mb-3 machineCamera-camera px-0"
        />
      </template>
      <template v-else>
        <img
          :id="cameraName"
          :src="cameraUrl"
          alt="機台關機中"
          class="machineCamera-camera px-0"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
export default {
  props: {
    machineCameraData: {
      type: Array,
      default: [],
    },
  },
  setup(props) {
    const allCamera = ref(false);
    const cameraName = ref("");
    const cameraUrl = ref("");
    const machineCameraDetail = ref({});
    const cameraButton = ref(0);

    //function
    const setMachineCameraData = () => {
      if (props.machineCameraData.length > 0) {
        props.machineCameraData.forEach((data) => {
          console.log(data.cameraName);
          console.log(data.url);
          machineCameraDetail.value[data.cameraName] = data.url;
        });
        cameraName.value = props.machineCameraData[0]["cameraName"];
        cameraUrl.value = props.machineCameraData[0]["url"];
        cameraButton.value = cameraName.value;
      } else {
        machineCameraDetail.value = {};
      }
    };
    const changeCamera = (data) => {
      if (data == "ALL") {
        allCamera.value = true;
      } else {
        allCamera.value = false;
        cameraName.value = data;
        cameraUrl.value = machineCameraDetail.value[data];
      }
    };

    onMounted(() => {
      setMachineCameraData();
    });

    watch(
      () => props.machineCameraData,
      () => {
        setMachineCameraData();
      }
    );

    return {
      allCamera,
      cameraName,
      cameraUrl,
      machineCameraDetail,
      cameraButton,
      changeCamera,
    };
  },
};
</script>

<style scoped>
.machineCameraData.select-button {
  background-color: var(--main-bg-color);
  border-color: var(--main-bg-color);
}
.machineCameraData {
  height: 2rem;
  line-height: 2rem;
  width: 4.25rem;
  padding: 0px;
  background-color: #cccccc;
  color: var(--main-font-color);
  border-color: #cccccc;
}
.machineCamera-camera {
  height: 31.25rem;
  width: auto;
  border-radius: 0.625rem;
}
.machineCamera-camera:last-child {
  margin-bottom: 0px !important;
}
</style>
